import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconInfoRound: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1333 0.5C5.33208 0.5 0.633331 5.19875 0.633331 11C0.633331 16.8012 5.33208 21.5 11.1333 21.5C16.9346 21.5 21.6333 16.8012 21.6333 11C21.6333 5.19875 16.9346 0.5 11.1333 0.5ZM12.1833 16.25H10.0833V9.95H12.1833V16.25ZM12.1833 7.85H10.0833V5.75H12.1833V7.85Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconInfoRound.defaultProps = iconDefaultProps;
IconInfoRound.displayName = 'IconInfoRound';

export default IconInfoRound;
